import type { Extend } from '@mentimeter/ragnar-dsc';
import type { MouseEventHandler, PropsWithChildren } from 'react';
import type { BoxT } from '@mentimeter/ragnar-ui/box';
import { Box } from '@mentimeter/ragnar-ui/box';
import { Clickable } from '@mentimeter/ragnar-ui/clickable';

const fullOpacityOnHover: Extend = () => ({
  '@media (hover: hover)': {
    ':hover': {
      opacity: 1,
    },
  },
});

interface ClickableOrReadonlyWrapper
  extends Pick<
    BoxT,
    | 'p'
    | 'minWidth'
    | 'width'
    | 'minHeight'
    | 'height'
    | 'bg'
    | 'justifyContent'
    | 'borderRadius'
    | 'as'
    | 'extend'
    | 'style'
    | 'aria-label'
  > {
  onClick: MouseEventHandler | null;
}

export const ClickableOrReadonlyWrapper = ({
  onClick,
  children,
  ...props
}: PropsWithChildren<ClickableOrReadonlyWrapper>) => {
  if (onClick === null) {
    return <Box {...props}>{children}</Box>;
  }

  return (
    <Clickable onClick={onClick} extend={fullOpacityOnHover} {...props}>
      {children}
    </Clickable>
  );
};
